function setLocalStorageItem(name: string, value: any) {
    localStorage.setItem(name, value);
}

function getLocalStorageItem(name: string) {
    let res = localStorage.getItem(name);

    return res;
}

function deleteLocalStorageItem(name: string) {
    localStorage.removeItem(name);

    return true;
}

export { 
    setLocalStorageItem,
    getLocalStorageItem,
    deleteLocalStorageItem
};